// cta animation
const headerbtn = document.querySelector(".header-contact-cta-link");
const headerbtnlink = document.querySelector(".header-contact-cta-link a span");
const hb = gsap.timeline({ paused: true });
hb.to(headerbtnlink, { duration: 0.2, y: -150, ease: "power2.in" });
hb.set(headerbtnlink, { y: 150 });
hb.to(headerbtnlink, { duration: 0.2, y: 0 });

headerbtn.addEventListener('mouseenter', function () {
    hb.play(0)
})

let headerres = gsap.matchMedia();

// header animation
gsap.set('.header-bg', {
    backgroundColor: '#15171E',
    opacity: 0
})

headerres.add("(min-width: 1023px)", () => {
gsap.set('.header_hamburger', {
    y: 50,
    opacity: 0,
})
})
headerres.add("(max-width: 1024px)", () => {
gsap.set('.header_hamburger', {
    y: 0,
    opacity: 1,
})
})
              
gsap.set('.scroll-top', {
    y: 60,
    opacity: 0
})

const sa = gsap.timeline({
    scrollTrigger: {
        start: 'top+=1',
        end: '+=1',
        toggleActions: 'play none none reverse',
        scrub: 2,
        // markers: true,
    }
})

headerres.add("(min-width: 1023px)", () => {
sa.to('.header_hamburger', {
    y: 0,
    opacity: 1,
}, 'header')
})  
sa.to('.site-navigation-nav', {
    y: -90,
    opacity: 0,
}, 'header')
sa.to('.header-content', {
    paddingTop: "15px",
    paddingBottom: "15px",
}, 'header')


const ha = gsap.timeline({
    scrollTrigger: {
        start: 'top+=500',
        end: '+=1',
        toggleActions: 'play none none reverse',
        scrub: 2,
        // markers: true,
    }
})

ha
.to('.header-bg', {
    opacity: 1
})